
export default function careersListing() {
  const root = document.querySelector('.careers-listing');
  if (!root) return false;

  const departments = [...document.querySelectorAll('.careers-department')];
  const jobs = [...document.querySelectorAll('.career-item')];

  const selectDep = root.querySelector('.select--department');
  const selectState = root.querySelector('.select--state');

  selectDep.addEventListener('change', ({currentTarget:{value}})=>{
    selectState.value = '#';
    jobs.forEach(j => j.classList.remove('hidden'));
    departments.forEach((d, i) => {
      if( value === '#') {
        d.classList.remove('hidden');
        if (i === 0) {
          d.classList.add('is-open');
        } else {
          d.classList.remove('is-open');
        }
      } else {
        if (d.getAttribute('data-dep') === value) {
          d.classList.remove('hidden');
          d.classList.add('is-open');
        } else {
          d.classList.add('hidden');
          d.classList.remove('is-open');
        }
      }
    })
  });


  selectState.addEventListener('change', ({currentTarget:{value}}) => {

    selectDep.value = '#';

    jobs.forEach((j) => {
      if (value === '#' || j.getAttribute('data-state') === value) {
        j.classList.remove('hidden');
      } else {
        j.classList.add('hidden');
      }
    });

    let first = true;
    departments.forEach((d, i) => {
      const shownJobsInDep = [...d.querySelectorAll('.career-item')].filter(j => !j.classList.contains('hidden')).length;
      if (!shownJobsInDep) {
        d.classList.add('hidden');
        d.classList.remove('is-open');
      } else {
        d.classList.remove('hidden');
        if (first) {
          d.classList.add('is-open');
          first = false;
        }
      }

    })
  });



  departments.forEach(d => {
    const header = d.querySelector('header');
    header.addEventListener('click', (e) => {
      d.classList.toggle('is-open');
    });
  });

}